import { DateRange } from 'react-day-picker'
import { LocationSelector } from 'components/LocationSelector'
import { PositionSelector } from 'components/PositionSelector'
import { WorkerSelector } from 'components/WorkerSelector'
import { SelectableOption } from 'typings/selectable_ext'
import { Box, Button, DatePicker, Flex } from 'ui'
import { useReviewEvaluateV2ContextValue } from '../context/ReviewEvaluateV2Provider'

export const FilterBar = () => {
  const {
    state: { filters },
    actions: { setFilters },
  } = useReviewEvaluateV2ContextValue()

  return (
    <Flex
      flexDirection={['column', 'column', 'row']}
      mb={2}
      position="relative"
      zIndex={2}
    >
      <Flex mb={2} flexWrap="wrap" width={[1, 1, 1 / 2]}>
        <Button
          variant={filters.reviewStatus === 'all' ? 'primary' : 'secondary'}
          mr={2}
          mb={2}
          onClick={() => setFilters({ reviewStatus: 'all' })}
        >
          All
        </Button>
        <Button
          variant={
            filters.reviewStatus === 'pending_review' ? 'primary' : 'secondary'
          }
          mr={2}
          mb={2}
          onClick={() => setFilters({ reviewStatus: 'pending_review' })}
        >
          Pending review
        </Button>
        <Button
          variant={
            filters.reviewStatus === 'reviewed' ? 'primary' : 'secondary'
          }
          mb={2}
          onClick={() => setFilters({ reviewStatus: 'reviewed' })}
        >
          Reviewed
        </Button>
      </Flex>

      <Flex flexWrap="wrap" width={[1, 1, 1 / 2]}>
        <Box width={[1, 1 / 2, 1 / 2, 1 / 4]} pr={[0, 2]} mb={2}>
          <DatePicker
            mode="range"
            selected={
              filters.startDate || filters.endDate
                ? ({
                    from: filters.startDate,
                    to: filters.endDate,
                  } as DateRange)
                : undefined
            }
            placeholder="Date"
            onSelect={(newDates) => {
              if (!newDates) {
                setFilters({ from: null, to: null })
                return
              }

              const typedDates = newDates as DateRange
              if (typedDates.from && typedDates.to) {
                setFilters({
                  from: typedDates.from,
                  to: typedDates.to,
                })
              }
            }}
          />
        </Box>

        <Box width={[1, 1 / 2, 1 / 2, 1 / 4]} pr={[0, 0, 2]} mb={2}>
          <LocationSelector
            value={filters.locationId}
            placeholder="Location"
            isClearable
            styles={{
              menu: (base) => ({ ...base, zIndex: 2 }),
            }}
            onChange={(newValue) => {
              if (!newValue) {
                setFilters({ locationId: null })
                return
              }
              const { value } = newValue as SelectableOption
              setFilters({ locationId: value ? Number(value) : null })
            }}
          />
        </Box>

        <Box width={[1, 1 / 2, 1 / 2, 1 / 4]} pr={[0, 2]} mb={2}>
          <PositionSelector
            value={filters.positionId}
            placeholder="Position"
            isClearable
            styles={{
              menu: (base) => ({ ...base, zIndex: 2 }),
            }}
            onChange={(newValue) => {
              if (!newValue) {
                setFilters({ positionId: null })
                return
              }
              const { value } = newValue as SelectableOption
              setFilters({ positionId: value ? Number(value) : null })
            }}
          />
        </Box>

        <Box width={[1, 1 / 2, 1 / 2, 1 / 4]} mb={2}>
          <WorkerSelector
            value={filters.workerId}
            placeholder="Worker"
            isClearable
            styles={{
              menu: (base) => ({ ...base, zIndex: 2 }),
            }}
            onChange={(newValue) => {
              if (!newValue) {
                setFilters({ workerId: null })
                return
              }
              const { value } = newValue as SelectableOption
              setFilters({ workerId: value ? Number(value) : null })
            }}
          />
        </Box>
      </Flex>
    </Flex>
  )
}
